import axios from './axios';
import common from './common.js';

export default {
  install(Vue, store, router) {
    // 总线, 挂载全局Bus上，可同过this.Bus.$emit(), this.Bus.$on()进行跨组件通讯
    const bus = new Vue();
    // 路由返回管理
    const routerGo = router.go.bind(router);
    router.go = (n) => {
      store.commit('REFRESH', false);
      routerGo(n);
    };
    // 模块动态注册
    store.registerModule('vm', {
      state: {
        isLoading: false, // 加载动画
        direction: '', // 划入(in)划出(out)
        routeData: {}, // 跳转的路由信息
        history: { '/': 1 }, // 历史路由管理
        historyCount: 1, // 路由数量
        includeList: [], // 缓存路由
        refresh: true, // 是否刷新缓存
      },
      mutations: {
        // 加载状态
        ISLOADING(state, payload) {
          state.isLoading = payload;
        },
        // 滑动方向
        DIRECTION(state, payload) {
          state.direction = payload;
        },
        // 跳转路由信息
        ROUTE: (state, payload) => {
          state.routeData = payload;
        },
        // 历史路由编号管理
        HISTORY: (state, payload) => {
          state.history = payload;
        },
        // 历史路由数量
        HISTORYCOUNT: (state, payload) => {
          state.historyCount = payload;
        },
        // 缓存页面数组
        INCLUDELIST: (state, payload) => {
          state.includeList = payload;
        },
        // 刷新缓存
        REFRESH: (state, payload) => {
          state.refresh = payload;
        },
      },
    });

    // 全局组件
    const componentList = [
      //swiper,
    ];
    // 挂载全局方法
    Vue.prototype.Bus = bus;
    Vue.prototype.$http = axios;

    for (const key in common) {
      Vue.prototype[`$${key}`] = common[key];
    }
    // 挂载全局组件
    componentList.forEach((t) => {
      Vue.component(t.name, t);
    });
    // 自定义指令
    // 组件内VNODE更新都会调用update,而非是绑定的div,但只能触发当前组件，不能触发父组件
    // 填充占位指令：v-fill = "{fill: true, height: '200px'} 只适应于内容异步加载，静态内容使用可能会出现未知异常,尤其是swiper类似插件
    Vue.directive('fill', {
      bind(el, binding) {
        el.dataset.fill = 'fill';
        const bindValue = binding.value || {};
        if (bindValue.fill) {
          el.childNodes.forEach((item) => {
            if (item && item.style) {
              const originClass = item.getAttribute('class') || '';
              item.setAttribute('class', `hide ${originClass}`);
            }
          });
          const divNode = document.createElement('div');
          divNode.setAttribute('class', 'mask');
          divNode.style.width = bindValue.width || '100%';
          divNode.style.height = bindValue.height || '100%';
          divNode.style.backgroundColor = bindValue.backgroundColor || '#eee';
          el.appendChild(divNode);
        }
      },
      update(el, binding) {
        const bindValue = binding.value || {};
        if (el.dataset.fill && !bindValue.fill) {
          el.dataset.fill = '';
          el.childNodes.forEach((item) => {
            if (item && item.style) {
              if (item.getAttribute('class') === 'mask') {
                el.removeChild(item);
              }
              let originClass = item.getAttribute('class') || ' ';
              originClass = originClass.replace('hide', '').slice(1);
              if (originClass) {
                item.setAttribute('class', originClass);
              } else {
                item.removeAttribute('class');
              }
            }
          });
        }
      },
    });
    // 自动获取光标指令: v-focus
    Vue.directive('focus', {
      inserted(el) {
        el.focus();
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/config/plugin.js